import { Any } from "../fakeTypes";

export enum WalletTypeV1 {
  MAIN = "main",
  FUNDING = "funding",
  SPOT = "spot",
  FUTURES = "futures",
  MARGIN = "margin",
  OPTIONS = "options",
  EARN = "earn",
  BOT = "bot",
  CARD = "card",
  OTHER = "other",
}

export const WALLET_TYPE = {
  SPOT: "spot",
  FUNDING: "funding",
  ISOLATED_MARGIN: "isolated_margin",
  CROSS_MARGIN: "cross_margin",
  USD_M_FUTURES: "usd_m_futures",
  USDT_M_FUTURES: "usdt_m_futures",
  USDC_M_FUTURES: "usdc_m_futures",
  COIN_M_FUTURES: "coin_m_futures",
  COIN_M_SWAP: "coin_m_swap",
  OPTIONS: "options",
  EARN: "earn",
  DERIVATIVES: "derivatives",

  // used when we don't have the separation
  FUTURES: "futures",

  // specific to Bybit
  INVERSE_DERIVATIVES: "inverse_derivatives",
  EARN_SPOT: "earn_spot",
  EARN_INNOVATION: "earn_innovation",
  INSURANCE_FUND: "insurance_fund",
  FUND: "fund",
  UNIFIED: "unified",

  UNKNOWN: "unknown",
} as const;
export type WALLET_TYPE = (typeof WALLET_TYPE)[keyof typeof WALLET_TYPE];

export enum WalletType {
  SPOT = "spot",
  FUNDING = "funding",
  ISOLATED_MARGIN = "isolated_margin",
  CROSS_MARGIN = "cross_margin",
  USD_M_FUTURES = "usd_m_futures",
  USDT_M_FUTURES = "usdt_m_futures",
  USDC_M_FUTURES = "usdc_m_futures",
  COIN_M_FUTURES = "coin_m_futures",
  COIN_M_SWAP = "coin_m_swap",
  OPTIONS = "options",
  EARN = "earn",
  DERIVATIVES = "derivatives",

  // used when we don't have the separation
  FUTURES = "futures",

  // specific to Bybit
  INVERSE_DERIVATIVES = "inverse_derivatives",
  EARN_SPOT = "earn_spot",
  EARN_INNOVATION = "earn_innovation",
  INSURANCE_FUND = "insurance_fund",
  FUND = "fund",
  UNIFIED = "unified",

  UNKNOWN = "unknown",
}

export function isWalletType(value: Any): value is WalletType {
  return Object.values(WalletType).includes(value);
}
